import pick from 'lodash/pick';

import {baseFields} from '@/modules/admin/contants/user.form';
import UserApiService from '@/modules/admin/services/UserApiService';
import {renderFieldPasswordWithLast} from '@/modules/authentication/components/PasswordWithLast';
import {useMe} from '@/modules/authentication/hooks/useUsers';
import {createEntityDetail} from '@/utils/createEntityDetail';
import {createFieldsHook} from '@/utils/createFieldsHook';
import createFormFieldset from '@/utils/createFormFieldset';

const fields = [
  ...baseFields,
  {
    key: 'security',
    colSpan: 2,
    render: createFormFieldset({title: 'user.form.security', translation: 'admin'}),
    onlyEdit: true,
  },
  {
    key: 'password',
    label: 'changePassword',
    colSpan: 2,
    onlyEdit: true,
    render: renderFieldPasswordWithLast,
  },
  {
    key: 'lastPassword',
    initialValue: '',
    noStyle: true,
    widgetProps: {
      hidden: true
    },
    required: false
  }
];

const useGetOne = () => {
  const {isLoading, data} = useMe();
  
  return {
    isLoading,
    data: {data}
  };
};

const mapPayload = payload => {
  const toPick = [
    'idNumber',
    'avatar',
    'firstName',
    'middleName',
    'lastName',
    'secondName',
    'username',
    'phone',
    'email',
    'address',
  ];
  
  const phone = payload?.phone === '' ? null : payload?.phone;
  const email = payload?.email === '' ? null : payload?.email;
  
  if (payload?.password) {
    toPick.push('lastPassword');
    toPick.push('password');
  }
  
  return pick({
    ...payload,
    phone,
    email,
  }, toPick);
};

const useFields = createFieldsHook('admin', fields.filter(({key}) => {
  let keys = ['roles', 'userType', 'ips', 'level', 'lastProposal'];
  return !keys.includes(key);
}));

export const NAME = 'PROFILE';
export const MODULE = 'PROFILE-MODULE';

export const {Detail: UserProfile, FormComponent: ProfileDialog} = createEntityDetail({
  module: MODULE,
  getOneKey: 'user-me',
  options: {
    create: false,
    edit: true,
    details: true
  },
  service: UserApiService,
  name: NAME,
  translation: 'profile',
  translationPrefix: 'user',
  willForceUpdate: true,
  useFields: useFields,
  useGetOne,
  mapPayload
});
